import { toEthereumAddressOrENSName } from './toEthereumAddressOrENSName';
/**
 * Create an instance of `StreamID` from a given string stream id or path.
 *
 * Supported formats:
 *  - full stream id format, e.g., '0x0000000000000000000000000000000000000000/foo/bar' or 'name.eth/foo/bar'
 *  - path-only format, e.g. , '/foo/bar'
 *  - legacy format, e.g., '7wa7APtlTq6EC5iTCBy6dw'
 *
 *  If `streamIdOrPath` is not in path-only format, `domain` can be left undefined.
 */
export function toStreamID(streamIdOrPath, domain) {
    if (streamIdOrPath.length === 0) {
        throw new Error('stream id may not be empty');
    }
    const firstSlashIdx = streamIdOrPath.indexOf('/');
    if (firstSlashIdx === -1) { // legacy format
        return streamIdOrPath;
    }
    else if (firstSlashIdx === 0) { // path-only format
        if (domain === undefined) {
            throw new Error(`path-only format "${streamIdOrPath}" provided without domain`);
        }
        return (domain + streamIdOrPath);
    }
    else {
        const domain = toEthereumAddressOrENSName(streamIdOrPath.substring(0, firstSlashIdx));
        const path = streamIdOrPath.substring(firstSlashIdx);
        return (domain + path);
    }
}
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class StreamIDUtils {
    static isPathOnlyFormat(streamIdOrPath) {
        return streamIdOrPath.startsWith('/');
    }
    static getDomain(streamId) {
        const domainAndPath = StreamIDUtils.getDomainAndPath(streamId);
        return domainAndPath?.[0];
    }
    static getPath(streamId) {
        const domainAndPath = StreamIDUtils.getDomainAndPath(streamId);
        return domainAndPath?.[1];
    }
    static getDomainAndPath(streamId) {
        const firstSlashIdx = streamId.indexOf('/');
        if (firstSlashIdx !== -1) {
            const domain = streamId.substring(0, firstSlashIdx);
            return [domain, streamId.substring(firstSlashIdx)];
        }
        else {
            return undefined;
        }
    }
}
//# sourceMappingURL=StreamID.js.map